import parsePlanFromResponse from '.'

function applyRules(state) {
  const { plansToShow, brochures, carriers, plans, filtersByProductType } = state
  state.plansData = plansToShow
    .map((planKey, index) => {
      const [planId, period, policies] = planKey.split('-')

      const filters = filtersByProductType[index]

      return filters
        ? parsePlanFromResponse({ plans, brochures, carriers }, planId, period, policies)
        : undefined
    })
    .filter(Boolean)
    .reduce((acc, plan) => {
      return {
        ...acc,
        [`${plan.planId}-${plan.period}-${plan.policies}`]: plan
      }
    }, {})
  return state
}

export default applyRules
